import {
  EDIT_QUIZZ_ANSWER,
  EDIT_QUIZZ_ANSWER_SUCCESS,
  EDIT_QUIZZ_ANSWER_CLEAN,
  EDIT_QUIZZ_ANSWER_ERROR,
} from "./actionTypes"

export const editQuizzAnswer = form => ({
  type: EDIT_QUIZZ_ANSWER,
  payload: { form },
})

export const editQuizzAnswerSuccess = answer => {
  return {
    type: EDIT_QUIZZ_ANSWER_SUCCESS,
    payload: { answer },
  }
}

export const editQuizzAnswerClean = () => {
  return {
    type: EDIT_QUIZZ_ANSWER_CLEAN,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: EDIT_QUIZZ_ANSWER_ERROR,
    payload: error,
  }
}
